import { Col, Row, Spin } from "antd";
import React from "react";
import { CustomContainer } from "./components/container";

const Loader = ({ padded = true, size = "large" }) => {
  const content = (
    <Row justify="center">
      <Col>
        <Spin size={size} />
      </Col>
    </Row>
  );

  return padded ? (
    <CustomContainer padTop="lg" padBottom="lg">
      {content}
    </CustomContainer>
  ) : (
    content
  );
};
export default Loader;
